import { Table, Button, Row, Col, Form, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetOpeningStoreStocksQuery, useDeleteOpeningStoreStockMutation } from './../slices/openingStoreStocksApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';


const StaffOpeningStoreStock = () => {
  // State for filtering, pagination, and date range
  const [filter, setFilter] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Fetch paginated openingStoreStocks data
  const { data, isLoading, error, refetch } = useGetOpeningStoreStocksQuery(pageNumber);

  // Mutation for deleting openingStoreStocks
  const [deleteOpeningStoreStock, { isLoading: loadingDelete }] = useDeleteOpeningStoreStockMutation();

  // Handle openingStoreStock deletion
  
  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this openingStoreStock?')) {
      try {
        await deleteOpeningStoreStock(id).unwrap();
        toast.success('OpeningStoreStock deleted successfully!');
        refetch(); // Refetch openingStoreStocks after successful deletion
      } catch (err) {
        toast.error(err?.data?.message || 'Failed to delete openingStoreStock.');
      }
    }
  };

  // Filter openingStoreStocks data based on product name, note, and date range
  const filterOpeningStoreStocks = () => {
    if (!data?.openingStoreStocks) return [];
    return data.openingStoreStocks.filter((openingStoreStock) => {
      const openingStoreStockDate = new Date(openingStoreStock.date);
      const isWithinDateRange =
        (!startDate || openingStoreStockDate >= new Date(startDate)) &&
        (!endDate || openingStoreStockDate <= new Date(endDate));
      return (
        isWithinDateRange &&
        (openingStoreStock.note?.toLowerCase().includes(filter.toLowerCase()) || // Check note
          openingStoreStock.openingStoreStockItems.some((item) =>
            item.name.toLowerCase().includes(filter.toLowerCase()) // Check product name
          ))
      );
    });
  };

  // Calculate total openingStoreStocks
  const calculateTotalOpeningStoreStocks = () => {
    return filterOpeningStoreStocks().reduce((total, openingStoreStock) => {
      const openingStoreStockTotal = openingStoreStock.openingStoreStockItems.reduce(
        (subTotal, item) => subTotal + item.qty * item.price,
        0
      );
      return total + openingStoreStockTotal;
    }, 0);
  };

  // Handle pagination changes
  const paginationHandler = (page) => {
    setPageNumber(page);
  };

  return (
    <>
      <Row className="align-items-center mb-3">
        <Col>
          <h1>OpeningMiniStocks</h1>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Filter by product name or note"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Start Date"
          />
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="End Date"
          />
        </Col>
        <Col md={6} className="text-end">
          <h4>Total OpeningStoreStocks: {calculateTotalOpeningStoreStocks().toFixed(2)}</h4>
        </Col>
      </Row>

      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || 'An error occurred'}
        </Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>DATE</th>
                <th>PRODUCT NAME</th>
                <th>QTY</th>
                <th>TOTAL</th>
                <th>NOTE</th>
                <th>IMAGE</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filterOpeningStoreStocks().map((openingStoreStock) =>
                openingStoreStock.openingStoreStockItems.map((item) => (
                  <tr key={`${openingStoreStock._id}-${item.product}`}>
                    <td>{new Date(openingStoreStock.date).toLocaleDateString()}</td>
                    <td>{item.name}</td>
                    <td>{item.qty}</td>
                    <td>{(item.qty * item.price).toFixed(2)}</td>
                    <td>{openingStoreStock.note || 'N/A'}</td>
                    <td>
                      {item.images && (
                        <img
                          src={item.images[0]}
                          alt="Thumbnail"
                          className="thumbnail-img me-2"
                          style={{
                            width: '10px',
                            height: '10px',
                            objectFit: 'cover',
                            borderRadius: '5px',
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <Button
                        as={Link}
                        to={`/openingStoreStock/${openingStoreStock._id}`}
                        variant="light"
                        className="btn-sm"
                      >
                        Details
                      </Button>
                      <Button
                         style={{ display: 'none' }}
                                              as={Link}
                                              to={`/admin/openingStoreStock/${openingStoreStock._id}/edit`}
                                              variant="light"
                                              className="btn-sm mx-2"
                                            > 
                                            Edit
                                            </Button>
                      <Button
                        style={{ display: 'none' }}
                        variant="danger"
                        className="btn-sm mx-2"
                        onClick={() => deleteHandler(openingStoreStock._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          <Pagination>
            {[...Array(data.pages).keys()].map((x) => (
              <Pagination.Item
                key={x + 1}
                active={x + 1 === pageNumber}
                onClick={() => paginationHandler(x + 1)}
              >
                {x + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      )}
    </>
  );
};

export default StaffOpeningStoreStock;
